module.exports = __webpack_public_path__ + "img/icon_instagram.4e07026a.png";